module.exports = __webpack_public_path__ + "media/images/btn-my-94b1116a7e786aa354c943037351421a.svg";